import { WorkspacePlansEnumValue } from "@panda0/panda0-graphql/defs";
import { fetcher } from "@panda0/panda0-utils";
import useSWR from "swr";

import { Folder } from "@/lib/types";
import useWorkspace from "./use-workspace";

export default function useFolder({ folderId }: { folderId?: string | null }) {
  const { id: workspaceId, plan, flags } = useWorkspace();

  const {
    data: folder,
    isValidating,
    isLoading,
  } = useSWR<Folder>(
    folderId &&
      workspaceId &&
      flags?.jobFolders &&
      plan !== WorkspacePlansEnumValue.kickstart
      ? `/api/v1/folders/${folderId}?workspaceId=${workspaceId}`
      : null,
    fetcher,
    {
      dedupingInterval: 60000,
      keepPreviousData: true,
    }
  );

  return {
    folder,
    loading: isLoading,
    isValidating,
  };
}
